import { useContext } from 'react';
import Context from './Context';

const usePreferences = () => useContext(Context);

export default usePreferences;
